import React from "react";
import { Link } from "react-router-dom";

import bg1 from "../assets/images/bg/financial-calculators.webp";
import pmb from "../assets/images/pmb.png";
import sbw from "../assets/images/sbw.png";
import mhb from "../assets/images/mhb.png";
import mmt from "../assets/images/mmt.png";
import pbs from "../assets/images/pbs.png";
import fbp from "../assets/images/fbp.png";
import drc from "../assets/images/drc.png";
import hmc from "../assets/images/hmc.png";
import hac from "../assets/images/hac.png";
import NavbarTwo from "../components/navbar/navbarTwo";
import FooterThree from "../components/footer/footerThree";
import ScrollTop from "../components/scrollTop";

export default function AboutUs() {
  const tools = [
    {
      title: "Debt Reduction Calculator",
      description:
        "How fast can i get out of debt?  Try different debt solutions.  List up to 20 creditors.",
      url: "https://www.vertex42.com/Calculators/debt-reduction-calculator.html",
      imgSrc: drc,
    },
        {
      title: "Home Mortgage Calculator",
      description:
        "Full-featured mortgage calculator.  Fixed-rate and adjustable-rate mortgages, Amortization schedule.",
      url: "https://www.vertex42.com/Calculators/home-mortgage-calculator.html",
      imgSrc: hmc,
    },
        {
      title: "Home Affordability Calculator",
      description:
        "Estimate the mortgage that you can afford based on income, debt-to-income ratio, down-payment, etc.",
      url: "https://www.vertex42.com/Calculators/home-affordability-calculator.html",
      imgSrc: hac,
    },
        {
      title: "Family Budget Planner",
      description:
        "Year‑long family budget worksheet with detailed categories (child care, etc.)",
      url: "https://www.vertex42.com/ExcelTemplates/family-budget-planner.html",
      imgSrc: fbp,
    },
        {
      title: "Vertex42 Money Manager",
      description:
        "All‑in‑one money management Excel template (Plan, Track, Analyze).",
      url: "https://www.vertex42.com/ExcelTemplates/money-management-template.html",
      imgSrc: mmt,
    },
    {
      title: "Personal Budget Spreadsheet",
      description:
        "Year‑long budget planner for a single person, fewer categories.",
      url: "https://www.vertex42.com/ExcelTemplates/personal-budget-spreadsheet.html",
      imgSrc: pbs,
    },
    {
      title: "Household Budget Worksheet",
      description:
        "Monthly household budget worksheet with detailed categories (e.g. children, pets).",
      url: "https://www.vertex42.com/ExcelTemplates/monthly-household-budget.html",
      imgSrc: mhb,
    },
    {
      title: "Simple Budget Worksheet",
      description:
        "Extremely simple monthly (or weekly/bi‑weekly) budget worksheet for beginners.",
      url: "https://www.vertex42.com/ExcelTemplates/simple-budget-worksheet.html",
      imgSrc: sbw,
    },
    {
      title: "Personal Monthly Budget",
      description:
        "Single‑page monthly personal budget vs actual spending comparison.",
      url: "https://www.vertex42.com/ExcelTemplates/personal-monthly-budget.html",
      imgSrc: pmb,
    },
  ];

  return (
    <>
      <NavbarTwo navClass="defaultscroll sticky" manuClass="navigation-menu nav-right nav-light" />

      <section
        id="page-top"
        className="bg-half-170 d-table w-100"
        style={{
          backgroundImage: `url(${bg1})`,
          backgroundPosition: "center",
        }}
      >
        <div className="bg-overlay bg-gradient-overlay"></div>
        <div className="container">
          <div className="row mt-5 justify-content-center">
            <div className="col-12">
              <div className="title-heading text-center">
                <h5 className="heading fw-semibold mb-0 page-heading text-white title-dark">
                  Financial Calculators Library
                </h5>
                <small className="text-white-50 mb-1 fw-medium text-uppercase mx-auto">
                  Trusted templates from Vertex42.com to help you budget with confidence
                </small>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="row justify-content-center mb-4">
            <div className="col-lg-10">
              <p className="text-muted2 text-center">
                <strong>Note:</strong> We do not receive any compensation or affiliate income from Vertex42. <b>We’re simply fans.</b> Over the years, we’ve used their budgeting templates ourselves and found them to be practical, easy to use, and genuinely helpful. That’s why we’ve curated this short list for you — so you can explore and use these free tools with the same confidence we have. <br></br>Links below are provided in accordance with Vertex42.com's acceptable use policies. 
              </p>
            </div>
          </div>
          <div className="row">
            {tools.map((tool, idx) => (
              <div className="col-md-4 mb-4" key={idx}>
                <div className="card h-100">
                  <img
                    src={tool.imgSrc}
                    className="card-img-top"
                    alt={`${tool.title} thumbnail`}
                  />
                  <div className="card-body d-flex flex-column">
                    <h5 className="card-title mt-auto">{tool.title}</h5>
                    <p className="card-text mt-auto">{tool.description}</p>
                    <a
                      href={tool.url}
                      className="btn btn-primary mt-auto"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View & Download
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FooterThree />
      <ScrollTop />
    </>
  );
}
